import { ClientChannelConfiguration } from "@shared/types";
import { useState } from "react";
import { AccountData } from "@shared/features/onboarding/types";

const useGroupOverviewProvider = () => {
  const [signalsGroupId, setSignalsGroupId] = useState<number>();
  const [displayedConfiguration, setDisplayedConfiguration] =
    useState<ClientChannelConfiguration>();
  const [selectedConfiguration, setSelectedConfiguration] =
    useState<ClientChannelConfiguration>();
  const [selectedAccountId, setSelectedAccountId] = useState<
    number | undefined
  >();
  const [accounts, setAccounts] = useState<AccountData[]>();

  return {
    signalsGroupId,
    setSignalsGroupId,
    displayedConfiguration,
    setDisplayedConfiguration,
    selectedConfiguration,
    setSelectedConfiguration,
    selectedAccountId,
    setSelectedAccountId,
    accounts,
    setAccounts,
  };
};

export default useGroupOverviewProvider;
